import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import { toast } from "react-hot-toast";

export const useGetAdministradoraPossuiAutenticacaoPartnerContaDigital = (usuarioLogadoId: string | null) => {
  const onError = () => {
    toast.error("Erro verificar dados da conta digital");
  };

  return useFetch<boolean>({
    key: ["adm-possui-autenticacao-partner-conta-digital", usuarioLogadoId],
    url: api.contaDigital.getAdministradoraPossuiAutenticacaoPartnerBank,
    pathVariables: usuarioLogadoId || undefined,
    enabled: usuarioLogadoId != null,
    onError,
  });
};
